import React, { Fragment } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import { withLocalize } from 'react-localize-redux';
import { dateTimeFormat, timeFormat } from '../../common/datetime';
import ErrorMessage from './errorMessage';

const HHDatePicker = props => {
  const {
    field,
    form: {
      setFieldValue, touched, errors, values
    },
    otherProps,
    type,
    translate
  } = props;

  let currentValue = field.value;

  if (typeof currentValue === 'string') {
    // convert to moment obj if it's a string datetime format
    currentValue = moment(currentValue);
  }

  const hasError = !!(touched[field.name] && errors[field.name]);
  let utcOffset = 0;
  // get utfOffset based on another field
  if (currentValue) {
    utcOffset =
      currentValue
        .tz(values.timezone || values.timeZone || otherProps.timezone || 'UTC')
        .utcOffset() / 60;
  }

  return (
    <Fragment>
      <DatePicker
        selected={field.value}
        onChange={dt => setFieldValue(field.name, dt)}
        showTimeSelect
        dateFormat={dateTimeFormat}
        timeFormat={timeFormat}
        utcOffset={utcOffset}
        popperPlacement='bottom-start'
        popperModifiers={{
          flip: {
            enabled: false
          },
          preventOverflow: {
            enabled: true,
            escapeWithReference: false
          }
        }}
        {...otherProps}
      />
      {
        type === 'livestreaming' && <small className='field-hint-msg'>{translate('recreateUrl')}</small>
      }
      {hasError && <ErrorMessage error={errors[field.name]} />}
    </Fragment>
  );
};

export default withLocalize(HHDatePicker);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhDatePicker.js